import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";


export default function CreateTicketModal({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create New Ticket</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="g-3">

          <Col md={6}>
            <div className="modal-card">
              <label>Ticket Title</label>
              <input type="text" placeholder="Enter title" />
            </div>
          </Col>

          <Col md={6}>
            <div className="modal-card">
              <label>Priority</label>
              <select>
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </select>
            </div>
          </Col>

          <Col md={12}>
            <div className="modal-card">
              <label>Description</label>
              <textarea rows="4" placeholder="Describe issue..." />
            </div>
          </Col>

        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="submit-btn">
          Submit Ticket
        </Button>
      </Modal.Footer>

      <style>{`
      .create-btn {
  background: linear-gradient(90deg, #ff7a18, #ff4d2d);
  border: none;
  color: #fff;
  font-weight: 500;
  padding: 8px 14px;
  border-radius: 6px;
}

.modal-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.modal-card label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

.modal-card input,
.modal-card select,
.modal-card textarea {
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
}

.submit-btn {
  background: #e9570e;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
}

@media (max-width: 576px) {
  .modal-card {
    margin-top: 10px;
  }
}
      
      `}</style>
    </Modal>
  );
}